import React from "react";
import "./ReportMetaField.css";

export function ReportMetaField({ label, value, variant = "print" }) {
  const isPrint = variant === "print";

  return (
    <div
      className={
        isPrint
          ? "erp-meta-field erp-meta-field--inline"
          : "er-meta-field er-meta-field--inline"
      }
    >
      <span className={isPrint ? "erp-meta-label" : "er-meta-label"}>
        {label}:
      </span>{" "}
      <span className={isPrint ? "erp-meta-value" : "er-meta-value"}>
        {value}
      </span>
    </div>
  );
}
